import axios from "axios";
import "./request_interceptor";


//const end_point1 = "http://192.168.30.225:88/api/services/charts/";
//const end_point1 = "https://preprodb.portailachats.ma/api/services/charts/";

const end_point1 = process.env.REACT_APP_API_URL + "/api/services/charts/";
////////////////////////////////////////////////////
//// bills
////////////////////////////////////////////////////

export const get_ChartsData_offers_number_byMonth = async (
  categorie,
  time_range
) => {
  return await axios.get(
    end_point1 +
      "get_ChartsData_offers_number_byMonth/" +
      categorie +
      "/" +
      time_range
  );
};
